import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { BuyerToSellerService } from '../buyer-to-seller/buyer-to-seller.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'itpx-leapest-message',
  templateUrl: './leapest-message.component.html',
  styleUrls: ['./leapest-message.component.css']
})
export class LeapestMessageComponent implements OnInit {
  private logo: string;
  @Input() message: string;
  @Input() proceed: Observable<string>;
  @Input() id: string;
  @Output() canProceed = new EventEmitter<boolean>();

  constructor(private service: BuyerToSellerService
  ) { }

  ngOnInit() {
    this.logo = this.service.getLogo();
    if (this.proceed && this.canProceed)
      this.proceed.filter(input => input === this.id).subscribe(_ => this.canProceed.emit(true));
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/buyer-to-seller-wrapper/leapest-message/leapest-message.component.ts